import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

/**
 * The RoundFilter function is a component in JavaScript that renders a filter for selecting rounds in
 * a search feature, with options that can be checked or unchecked.
 * @returns The RoundFilter component is returning a JSX element.
 */
function RoundFilter({ RoundOptions, setRoundOptions, customPathname, menu, label = "Round", isPopupOpen, setIsPopupOpen }) {
    const { Rounds, refineSearchFilters } = useContext(PeFilterContext);
    
    // Use internal state only if props are not provided (for backward compatibility)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const roundsToDisplay = menu === "vc" ? Rounds.filter(round => ["Equity", "Pre-Seed", "Bridge", "Seed", "Pre-Series", "1", "2", "3", "4", "5", "6", "7"].includes(round.name)) : Rounds;
        const roundIds = refineSearchFilters[customPathname]?.round?.map(value => value.id) ?? [];
        setRoundOptions(roundsToDisplay.map(round => ({ ...round, isChecked: roundIds.includes(round.id) })));
    }, [Rounds, customPathname, refineSearchFilters, setRoundOptions]);

    const handleRoundChange = (e) => {
        const { id, checked, name, filteredIds } = e.target;
        
        // Handle "Select All" / "Deselect All" functionality
        if (name === 'filteredSelect') {
            const updatedRounds = RoundOptions.map(round =>
                filteredIds.includes(round.id) ? { ...round, isChecked: checked } : round
            );
            setRoundOptions(updatedRounds);
        } else {
            // Handle individual checkbox changes
            const updatedRounds = RoundOptions.map(round =>
                round.id === parseInt(id) ? { ...round, isChecked: checked } : round
            );
            setRoundOptions(updatedRounds);
        }
    };

    const selectedRoundLength = RoundOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {RoundOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedRoundLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedRoundLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleRoundChange}
                            primaryEntity={RoundOptions}
                            searchBox={false}
                            round={true}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default RoundFilter;